import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  OnInit,
} from '@angular/core';
import { TrackingScreenNamesEnum } from '../../../tracking/tracking.data';
import {
  I2gNgTrackingActionBuilder,
  I2gNgTrackingService,
  ITrackingObject,
  ITrackingAction,
} from 'i2g-ng-tracking';
import { Observable } from 'rxjs';
import { AccountStore } from '../../store/stores';
import { shareReplay } from 'rxjs/operators';
import { AlignmentEnum, IconSizesEnum, IIcon, IRouter } from 'i2g-ng-ui';
import { AccountDispatcher } from '../../store';

@Component({
  selector: 'app-set-password-success',
  templateUrl: './set-password-success.component.html',
  styleUrls: ['./set-password-success.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SetPasswordSuccessComponent implements OnInit, AfterViewInit {
  successIcon: IIcon;
  trackingScreenName: TrackingScreenNamesEnum;
  trackingObject$: Observable<ITrackingObject>;
  loginRoute: IRouter;
  AlignmentEnum: typeof AlignmentEnum;
  loginTrackingAction: ITrackingAction;

  constructor(
    private _trackingService: I2gNgTrackingService,
    private _trackingActionBuilder: I2gNgTrackingActionBuilder,
    private _accountStore: AccountStore,
    private _accountDispatchers: AccountDispatcher
  ) {}

  ngOnInit() {
    this.AlignmentEnum = AlignmentEnum;
    this.trackingScreenName = TrackingScreenNamesEnum.set_password_success;
    this.trackingObject$ = this._accountStore
      .getTrackingObject()
      .pipe(shareReplay(1));
    this.loginTrackingAction = this._trackingActionBuilder.buildButtonTapped(
      'sign_in',
      this.trackingScreenName
    );

    this.successIcon = {
      name: 'success',
      size: IconSizesEnum.custom,
    };
  }

  ngAfterViewInit() {
    this._trackingService.trackPage(this.trackingScreenName);
  }

  goToLogin() {
    this._accountDispatchers.goToLogin();
  }
}
